import { Component, OnInit, ViewEncapsulation, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { FeesService } from '../../services/fees.service';
import { MenuUtils } from '../../../../../utils/menu-utils';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { FeeSummary } from '../../models/fee-summary';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { InterCopmonentDataCarrierService } from '../../../../../services/inter-copmonent-data-carrier-service/inter-copmonent-data-carrier.service';
import { AcademicYear } from 'src/app/models/academic-year';
import { AcademicYearService } from 'src/app/services/user/academic-year/academic-year.service';

class FeeGroup {
  public groupName: string;
  public feeInstallments: FeeSummary[];
  constructor(name: string) {
    this.groupName = name;
    this.feeInstallments = [];
  }
}

@Component({
  selector: 'app-fees',
  templateUrl: './fees.component.html',
  styleUrls: ['./fees.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FeesComponent extends ComponentBase implements OnInit {

  constructor(private feesService: FeesService,
    private pageHeadingService: PageHeadingService,
    private routingService: RoutingService,
    private interCopmonentDataCarrierService: InterCopmonentDataCarrierService
    , private renderer: Renderer2
    , private academicYearService: AcademicYearService) {
    super();
  }

  feeGroups: FeeGroup[];
  hasFees: boolean = false;
  noDataMessage = 'Loading...';
  
  academicYear: AcademicYear;
  
  ngOnInit() {
    this.pageHeadingService.menuOnChange(MenuUtils.getMenuItem("Fees"));
    let subscription = this.feesService.getFeeInstallments()
      .subscribe(res => {
        this.feeGroups = this.groupPayments(res);
      })
    this.addSubscription(subscription);
    
    let sub1 = this.academicYearService.getAcademicYear()
      .subscribe(res => {
        this.academicYear = res;
      });
    this.addSubscription(sub1);

  }

  groupPayments(fees: FeeSummary[]) {
    if (fees.length) {
      this.hasFees = true;
    } else {
      this.noDataMessage = 'No fee data available';
    }

    let paidFees = new FeeGroup("Paid Fees");
    let pendingFees = new FeeGroup("Pending Fees");
    let overdueFees = new FeeGroup("Overdue Fees");

    fees.forEach(fee => {
      if (fee.is_installment_completely_paid) {
        paidFees.feeInstallments.push(fee);
      } else if (!fee.is_installment_completely_paid && fee.due_in_days > 0) {
        pendingFees.feeInstallments.push(fee);
      } else {
        overdueFees.feeInstallments.push(fee);
      }
    });
    return [paidFees, pendingFees, overdueFees];
  }

  payNowClicked(fee: FeeSummary) {
    this.interCopmonentDataCarrierService.save("fee_item", fee);
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'fee-details'];
    route.append_current_url_to_history = true;
    this.renderer.addClass(document.body, 'second-page');
    this.routingService.navigate(route);
  }
}
